var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"https://vandar.io"}},[_c('v-img',{attrs:{"src":_vm.$store.state.vandarIconCdn,"width":"38","alt":"Vandar"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }